import { render, staticRenderFns } from "./PriceLabel.vue?vue&type=template&id=d303e12c&"
import script from "./PriceLabel.vue?vue&type=script&lang=js&"
export * from "./PriceLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports